import "components/order/style/OrderDetail.css";

const OrderContents = ({
  payIndex,
  basket,
  basketDeleteHandler,
  pointHandler,
}) => {
  const MenuListComponent = () => {
    const mList = basket.rows.map((menu, index) => {
      const MenuCateList = ({ mCateList }) => {
        return mCateList.map((cate) => {
          return (
            <>
              <div className="order_option">
                <p className="option_area">{cate.moc_name}</p>
              </div>
              {cate.optionArray.map((opt) => {
                return (
                  <li>
                    <span className="opction-class"></span>
                    <div className="opciton-price-box">
                      <span className="opction-name">
                        <p>└</p>
                        {opt.mo_name}
                      </span>
                      <span>
                        <p>
                          {opt.mo_price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                          <span className="font-weght-light">원</span>
                        </p>
                        <p>
                          {opt.mo_count}
                          <span className="font-weght-light">개</span>
                        </p>
                      </span>
                    </div>
                  </li>
                );
              })}
            </>
          );
        });
      };

      return (
        <>
          <div className="order-menu-name-box" data-tprice={menu.totalPrice}>
            <span className="menu-name">{menu.m_name}</span>
            <span className="menu-price">
              <p>
                {menu.optionCateArray.length > 0
                  ? menu.totalPrice
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : menu.m_price
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                {""}
                <span className="font-weght-light2">원</span>
              </p>
              <p>
                {menu.m_count}
                <span className="font-weght-light2">개</span>
              </p>
              <button
                className="order-cancel-button"
                onClick={() => {
                  basketDeleteHandler(menu.bm_idx);
                  pointHandler.pointReset();
                }}
              ></button>
            </span>
          </div>
          {menu.optionCateArray.length > 0 && (
            <MenuCateList mCateList={menu.optionCateArray} />
          )}
        </>
      );
    });

    return <ul className="order-content-list">{mList}</ul>;
  };
  return (
    <div className="order-content">
      {/* <div className="underline"></div> */}
      <div className="wrap_frame">
        <div className="wrap_frame-wrap">
          <div className="order-content-title">
            <span className="order-title-light">주문 내용</span>
            <button className="drop-down"></button>
          </div>
          {basket && <MenuListComponent />}
        </div>
      </div>
    </div>
  );
};

export default OrderContents;
